<div class="wpee-profile-header">
    <div class="wpee-profile-header has-ph-menu">
        <div class="profile-cover-photo">
            <span class="profile-cover-image overlay" [ngClass]="{ 'shine': loader || banner_loader }"
                [ngStyle]="{'background-image': 'url(' + imagePreview + ')',}">
            </span>
        </div>

        <div class="wpee-container">
            <!-- User Profile Detail Start -->
            <div class="profile-user-details d-flex align-bottom" style="margin-top: -200px;">
                <!-- Profile Image Start -->
                <div class="profile-img change-profile-image p-rel">

                    <div class="loader" style="display: none"></div>

                    <figure class="overflow-h" [ngClass]="{ 'shine': loader || profile_loader }" (click)="openImageModal(profileimg)">
                        <a class="group1 profile_picture_link" *ngIf="!loader && !profile_loader">
                            <img [src]="profileimg" class="img" [ngClass]="{ 'shine': loader }" id="profile_picture"
                                alt="profile">
                        </a>
                    </figure>
                    <div class="update_profile_text_div" title="Update Profile Picture" *ngIf="is_my_profile">
                        <a id="change-profile-pic" class="" (click)="triggerFileUpload_profile(fileInput2)">
                            <fa-icon [icon]="faCamera"></fa-icon>
                        </a>
                        <input type="file" (change)="onFileSelected_profile($event)" #fileInput2 style="display:none"
                        accept=".jpg, .jpeg, .png" />
                    </div>

                    <div class="wpee-user-status wpee-offline"></div>
                </div>

                <div class="user-info-wrapper">
                    <h4 class="username text-white" [ngClass]="{ 'shine': loader }">{{loader? '': name}}</h4>
                    <!-- <div class="account-status" *ngIf="is_free_member">
                        <div class="profile-location">
                            <span class="profile-status-title">Account Level:</span>
                            Free Member
                        </div>
                    </div> -->

                    <div class="age-location-wrap text-white">
                        <div class="profile-age " *ngIf="age">
                            <span class="age-title" >Age: </span>
                            <span [ngClass]="{ 'shine': loader }" class="bnr_age_location"> {{loader? '':' '+age}}</span>
                        </div>
                        <div class="profile-location" *ngIf="Contry || location">
                            <span class="location-title">Location: </span>
                            <span [ngClass]="{ 'shine': loader }" class="bnr_age_location"> {{loader? '':' '+location?location:''}} {{loader? '':Contry?Contry:''}}</span>
                        </div>
                    </div>

                </div>
                <!-- User Information End -->
                <div class="profile-header-right d-flex">
                    <div [ngClass]="{ 'shine': loader }">
                        <span></span>
                    </div>
                    <div class="wpee-friend-request" *ngIf="!is_my_profile && !loader">
                        <a class="dsp-btn-default" (click)="sendFriendRequest()" (mouseover)="hovering = true"
                            (mouseleave)="hovering = false">
                            <span class="friend-request-info-text" *ngIf="friendStatus == 0 ">Add Friend</span>
                            <span class="friend-request-info-text" *ngIf="friendStatus == 1 ">Cancel Friend
                                Request</span>
                            <span class="friend-request-info-text" *ngIf="friendStatus == 2">
                                {{ hovering ? 'Unfriend' : 'Friends' }}
                            </span>
                            <span class="friend-request-info-text" *ngIf="friendStatus == 3">
                                Accept Friend Request
                            </span>
                            <span class="friend-request-loader" [class.show-loader]="showLoader">
                                <mat-spinner></mat-spinner>
                            </span>
                        </a>
                    </div>
                    <!-- Send Friend Request -->
                    <!-- Block user -->
                    <div class="wpee-block-user" *ngIf="!is_my_profile && !loader">
                        <a class="dsp-btn-default" (click)="is_block = true">
                            Block this user </a>
                    </div>

                    <div class="edit_cover" *ngIf="is_my_profile && !loader">
                        <a class="dsp-btn-default" (click)="triggerFileUpload_banner(fileInput1)"><fa-icon
                                [icon]="faCamera"></fa-icon>Edit Cover Photo</a>
                        <div class="form-filed">
                            <input type="file" (change)="onFileSelected_banner($event)" #fileInput1 style="display:none"
                            accept=".jpg, .jpeg, .png" />
                        </div>
                    </div>
                    <!-- Block user -->
                </div>
            </div>
            <div class="dim-profile-message">Please be aware your profile will not appear on the Members Page until you
                complete all of the fields in the <b>'Edit Profile'</b> section.</div>
        </div>
    </div>
</div>

<div class="album-popup-main-wrapper popup-main-wrapper" [ngClass]="{'is-open':is_block}">
    <span class="album-pop-up-bg pop-up-bg" (click)="is_block = false"></span>
    <div class="album-popup-wrapper popup-wrapper">
        <h6 class="album-popup-title popup-title">Block User</h6>
        <span class="close_icon" (click)="is_block = false"><img [src]="this.apiService.frontendAssetsUrl+'close.svg'" alt=""></span>
        <div class="delete_alert">
            <p>Are you sure want to block {{userName}}?</p>
        </div>
        <div class="delete_btns">
            <button class="save-button" (click)="is_block = false">No</button>
            <button class="save-button d-flex" (click)="confirmBlock()">
                <mat-spinner *ngIf="!showText"></mat-spinner>
                <span *ngIf="showText">Yes</span>
            </button>
        </div>
    </div>
</div>

<div class="pintura-editor" *ngIf="showPinturaEditor">
    <pintura-editor [src]="src" [options]="options" (process)="handleProcess($event)"
        (close)="onEditorClose()"></pintura-editor>
</div>